/**
 * @Author：zsj
 * @Date：2022/03/08
 */

const devBaseURL = "/";
const fatBaseURL = "/";
const proBaseURL = "/";

const httpEnv = process.env.REACT_APP_HTTP_ENV

export const BASE_URL = httpEnv === 'dev' ? devBaseURL : (httpEnv === 'fat' ? fatBaseURL : proBaseURL); // --deploy_auto_replace--


export const TIMEOUT = 20000;
